module.exports = __webpack_public_path__ + "static/media/img_wear-insert-02.f3a91241.svg";